import axios from 'axios';
import CONFIG from '../config';

export const getTranslations = (lang) => axios.get(`/translations/${lang}.json?v=${CONFIG.VERSION}`).then(response => response.data);
